import { Stack } from '@mui/material';
import { FC } from 'react';

import Reset from '@vp/assets/icons/Reset.svg?react';
import Share from '@vp/assets/icons/Share.svg?react';
import { VpFade } from '@vp/common/ui/component/VpFade';
import { useViewModel } from '@vp/common/ui/hook/useViewModel';
import { AccessManagerActionButton } from '@vp/manager/access/ui/AccessManagerActionButton';
import { AccessManagerCode } from '@vp/manager/access/ui/AccessManagerCode';
import { AccessManagerControls } from '@vp/manager/access/ui/AccessManagerControls';
import { AccessManagerHeader } from '@vp/manager/access/ui/AccessManagerHeader';
import { AccessManagerViewModel } from '@vp/manager/access/ui/AccessManagerViewModel';
import { AccessManagerSettings } from '@vp/manager/access/ui/settings/AccessManagerSettings';

export const AccessManagerPage: FC = () => {
  const viewModel = useViewModel(AccessManagerViewModel);

  return (
    <VpFade sx={{ height: '100dvh', width: 1, display: 'flex', flexDirection: 'column' }}>
      <AccessManagerHeader />

      <Stack gap={3} mt={2} alignItems="center">
        <AccessManagerCode disabled={viewModel.applying.value} code={viewModel.updated.value.code} onChange={viewModel.onCodeChange} />

        <AccessManagerActionButton
          Icon={Reset}
          text="Сгенерировать код автоматически"
          disabled={viewModel.applying.value}
          onClick={viewModel.generateRandomCode}
        />

        <AccessManagerSettings
          disabled={viewModel.applying.value}
          access={viewModel.updated.value}
          onFullRestrictionToggle={viewModel.onFullRestrictionToggle}
          onSectionToggle={viewModel.onSectionToggle}
        />

        <AccessManagerActionButton
          Icon={Share}
          text="Поделиться профилем без пароля"
          disabled={viewModel.shareButtonDisabled.value}
          onClick={viewModel.shareProfileWithoutPassword}
        />
      </Stack>

      <AccessManagerControls
        applying={viewModel.applying.value}
        shown={viewModel.changed.value}
        onCancel={viewModel.cancelChanges}
        onApply={viewModel.applyChanges}
      />
    </VpFade>
  );
};
